import { Button, Result } from 'antd'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { contextCompanyIdSelector } from '../../../../../redux/context/company/selectors'
import { useBackend } from '../../../../../services/backend'
import { Loading } from '../../../../../components/Misc/Loading'
import { useIntegrationDocsURL } from '../../../../../utils/docs'
import DataUpdate from '../dataUpdate'

const Procountor: React.FC = () => {
  const { t } = useTranslation()
  const integrationDocs = useIntegrationDocsURL()
  const companyId = useSelector(contextCompanyIdSelector)
  const [authorized, setAuthorized] = useState(false)
  const getCredentials = useBackend(`/procountor/authentication/{companyId}`, process.env.REACT_APP_INTEGRATION_URL)

  const authButton = () => {
    return (
      <>
        <Button
          href={`${process.env.REACT_APP_INTEGRATION_URL}/oauth2/procountor/authenticate/${companyId}`}
          target="_blank"
          type="primary"
        >
          {t('integrationsPage:authenticate')}
        </Button>
        {authorized && <DataUpdate page="procountor" />}
      </>
    )
  }

  const getCredentialsHandler = () => {
    getCredentials
      .get({
        urlParams: { companyId }
      })
      .then((response: any) => {
        switch (response.httpCode) {
          case 401:
            setAuthorized(false)
            break
          default:
            break
        }
        if (response.apiKey || response.refreshToken) setAuthorized(true)
      })
      .catch(() => {
        setAuthorized(false)
      })
  }

  useEffect(getCredentialsHandler, [companyId])

  if (getCredentials.loading) {
    return <Loading />
  }
  if (!authorized) {
    return (
      <>
        <a href={integrationDocs.accounting('procountor')} target="_blank" rel="noopener noreferrer">
          {t('header:manual')}
        </a>
        <Result status="info" title={t('integrationsPage:notAuthenticated')} extra={authButton()} />
      </>
    )
  }
  return (
    <>
      <a href={integrationDocs.accounting('procountor')} target="_blank" rel="noopener noreferrer">
        {t('header:manual')}
      </a>
      <Result status="success" title={t('integrationsPage:authenticated')} extra={authButton()} />
    </>
  )
}

export default Procountor
